( function ( $ ) {

	MP.responsvie = function(){
		function make(){
			if ( lib.viewport().width < tablet ){
				$('body').addClass('is-tablet');
			} else {
				$('body').removeClass('is-tablet');
			}
		}
		make();
		window.addEventListener('resize',make);
	};

	window.addEventListener('load',function(){
		$('body').addClass('is-loaded');
	});

}) ( window.jQuery);


// WEBPACK FOOTER //
// ./assets/js/a-responsive.js